export default __webpack_public_path__ + "static/media/huetchen.14ad73ee.svg";